import { forwardRef } from "react";

import { Divider, DividerProps, useTheme } from "@mui/material";

import { InvalidThemeErrorMessage } from "../InvalidThemeErrorMessage";

import { mergeSx } from "@/helpers/mergeSx";

export type FormDividerProps = DividerProps;

export const FormDivider = forwardRef<HTMLHRElement, FormDividerProps>(({ sx, ...rest }, ref) => {
  const theme = useTheme();

  if (!theme.palette.formsComponents?.divider) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Divider {...rest} ref={ref} sx={mergeSx({ borderColor: theme.palette.formsComponents.divider.borderColor }, sx)} />
  );
});

FormDivider.displayName = "FormDivider";
